import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MonitoreoFlujoTramiteService } from "../../servicios/monitoreo-flujo-tramite.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import {
  MonitoreoFlujoTramite,
  MonitoreoFlujoTramiteInput,
  SolicitudDetalles,
  Aguas,
  RAguasPersonas, 
  Personas,
  ParametroJasper,
  AuxJasper,
  FlujoTramitesInput
} from "../../entidades/entidades";
import { Router } from "@angular/router";

import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { RConceptosRequisitosService } from "../../servicios/r-conceptos-requisitos.service";
import { AguasService } from "app/servicios/aguas.service";
import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { PersonasService } from "app/servicios/personas.service";
import { Observable, empty } from "rxjs";
import { JasperService } from "../../servicios/jasper.service";
import { FlujoTramitesInputService } from "../../../app/servicios/flujo-tramites.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";

declare var $: any;
@Component({
  selector: "app-monitoreo-flujo-tramite",
  templateUrl: "./monitoreo-flujo-tramite.component.html",
  styleUrls: ["./monitoreo-flujo-tramite.component.css"],
})
export class MonitoreoFlujoTramiteComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  monitoreoFlujoTramiteForm: FormGroup;
  MonitoreoFlujoTramiteTable: MonitoreoFlujoTramite;
  public idSolicitud: number;
  public idAgua: number;
  public persona: number;
  columnasTabla: any[];
  public auxJasper: AuxJasper;
  public imprime: boolean;
  public VentanaRegresaFlujo: boolean = false;
  public observacionRegreso: string = '';
  public tableWidget: any;
  public fti: FlujoTramitesInput;
  @Input("MonitoreoFlujoTramiteInput")
  MonitoreoFlujoTramiteInput: MonitoreoFlujoTramiteInput;
  @Input("conceptoSeleccionado") conceptoSeleccionado: string;
  @Input("readOnly") readOnly: boolean;
  @Output("monitoreoFlujoTramiteOutput")
  monitoreoFlujoTramiteOutput: EventEmitter<MonitoreoFlujoTramite>;
  @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;
  public personas$: Observable<Personas>;

  constructor(
    private formBuilder: FormBuilder,
    private monitoreoFlujoTramiteService: MonitoreoFlujoTramiteService,
    private route: ActivatedRoute,
    private router: Router,
    private solicitudDetallesService: SolicitudDetallesService,
    private rConceptosRequisitosService: RConceptosRequisitosService,
    private aguasService: AguasService,
    private rAguasPersonasService: RAguasPersonasService,
    private personasService: PersonasService,
    public _jasperService: JasperService,
    private solicitudesService: SolicitudesService,
    private flujoTramitesInputService : FlujoTramitesInputService,
  ) {
    this.monitoreoFlujoTramiteOutput = new EventEmitter();
    this.aguasOutput = new EventEmitter();
    this.monitoreoFlujoTramiteForm = new FormGroup({
      idSolicitud: new FormControl(),
      estadoTramite: new FormControl(),
      fecha: new FormControl(),
      usuario: new FormControl(),
      estatus: new FormControl(),
      
    });
  }

  ngOnInit() {
    this.monitoreoFlujoTramiteForm = this.formBuilder.group({
      idSolicitud: [undefined],
      estadoTramite: [undefined],
      fecha: [undefined],
      usuario: [undefined],
      estatus: [undefined],
    });

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    this.columnasTabla = [
      {field: "tramite",header: "Trámite",ordenar: false,styleHeader: "width: 130px;",},
      {field: "fecha",header: "Fecha",ordenar: false,styleHeader: "width: 130px;",},
      {field: "usuario",header: "Usuario",ordenar: false,styleHeader: "width: 180px;",},
      {field: "estatus",header: "Estatus",ordenar: false,styleHeader: "width: 140px;",},
      {field: "accion",header: "Acción",ordenar: false,styleHeader: "width: 55px;",}
    ];
  
  }
  ngOnChanges() {
    if (this.MonitoreoFlujoTramiteInput) {
      this.getMonitoreoFlujoTramite(this.MonitoreoFlujoTramiteInput);
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================

  ngAfterViewInit() {
    this.initDatatable();
  }

  private initDatatable(): void {
    const tabla: any = $("#tablaMonitoreo");
    this.tableWidget = tabla.DataTable({
      scrollX: true,
      destroy: true,
      filter: false,
      language: {
        "sProcessing":     "Procesando...",
        "sLengthMenu":     "Mostrar _MENU_ registros",
        "sZeroRecords":    "No se encontraron resultados",
        "sEmptyTable":     "Ningún dato disponible en esta tabla",
        "sInfo":           "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty":      "Registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix":    "",
        "sSearch":         "Buscar:",
        "sUrl":            "",
        "sInfoThousands":  ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
            "sFirst":    "Primero",
            "sLast":     "Último",
            "sNext":     "Siguiente",
            "sPrevious": "Anterior"
        },
        "oAria": {
            "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
            "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        "buttons": {
            "copy": "Copiar",
            "colvis": "Visibilidad"
        }
    }
  });
  }

  
  private reInitDatatable(): void {
    this.tableWidget.destroy();
    setTimeout(() => this.initDatatable(), 0);
  }
  async getMonitoreoFlujoTramite(MonitoreoFlujoTramiteInput: MonitoreoFlujoTramiteInput){
    try {
      const datoRetorno = await this.monitoreoFlujoTramiteService.getBusquedas(MonitoreoFlujoTramiteInput)
        .toPromise();
      
      this.MonitoreoFlujoTramiteTable = datoRetorno;
      this.idSolicitud = datoRetorno[0].idSolicitudDetalle;
      this.idAgua = datoRetorno[0].idAgua;
      this.reInitDatatable();
      this.monitoreoFlujoTramiteOutput.emit(datoRetorno);

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getMonitoreoFlujoTramite");
    }
  }

  async getAllMonitoreoFlujoTramite() {
    try {
      const datoRetorno = await this.monitoreoFlujoTramiteService
        .getAll()
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllMonitoreoFlujoTramite");
    }
  }

  async ejecuta(row: any)
  {
    try{
      let monitoreoFlujoTramite = new MonitoreoFlujoTramite;
      monitoreoFlujoTramite = row;          
      const buscaSolicitud = await this.solicitudDetallesService.getSingle(row.idSolicitudDetalle).toPromise();  
      let requisitos = [];
      // requisitos.push(await this.rConceptosRequisitosService.getSingle(buscaSolicitud.idConcepto).toPromise());
      // console.log('buscaRequisitos: ',requisitos);
      if(buscaSolicitud.idConcepto)
      {
        const datoRetorno = await this.rConceptosRequisitosService.getSingle(buscaSolicitud.idConcepto).toPromise()
        const numero = Object.keys(await this.rConceptosRequisitosService.getSingle(buscaSolicitud.idConcepto).toPromise());
        for(var index of numero) {
          requisitos[index] = datoRetorno[index];
        }
        for(var i = 0; i < requisitos.length; i++)
        {
          if(requisitos[i].idRequisito == 7 && buscaSolicitud.idAgua == null && buscaSolicitud.idConcepto != 1 && buscaSolicitud.idConcepto != 2
            && buscaSolicitud.idConcepto != 3 && buscaSolicitud.idConcepto != 4 && buscaSolicitud.idConcepto != 77 )
          {
            this.muestraMensaje.error("Este servicio requiere de una cuenta.", "top", "center");
            throw new Error("Este servicio requiere de una cuenta.");
          }else{
          }
        }
  
      }
      if(monitoreoFlujoTramite.estadoTramite == 'SOLICITUD'){
        await this.imprimir(monitoreoFlujoTramite.idSolicitud);
      } else if (monitoreoFlujoTramite.estadoTramite == 'CONTRATACIÓN (FIRMA)' && monitoreoFlujoTramite.estatus == 'TERMINADO') {
        this.router.navigate([monitoreoFlujoTramite.rutaPagina], 
          {
            state: { example: monitoreoFlujoTramite }
          });
      }
      else if(monitoreoFlujoTramite.estadoTramite == 'COBRO' && monitoreoFlujoTramite.estatus == 'EN PROCESO')
      {
        this.VentanaRegresaFlujo = true;
      }
      else if(monitoreoFlujoTramite.estadoTramite == 'COBRO' && monitoreoFlujoTramite.estatus == 'TERMINADO')
      {
        await this.imprimirReciboPago(monitoreoFlujoTramite.idSolicitudDetalle);
      }
      else
      {
        this.router.navigate([monitoreoFlujoTramite.rutaPagina], 
          {
            state: { example: monitoreoFlujoTramite }
          });
      }  
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }
  }
  async imprimir(_idSolicitud) {
    try {
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "Solicitud";
      this.auxJasper.JasperReport.tipo = "pdf";

      let parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_solicitud";
      parametroJasper.valor = _idSolicitud + "";

      let parametroJasperFl = new ParametroJasper();
      parametroJasperFl.nombre = "par_seguimiento_t";
      parametroJasperFl.valor = "false";

      await this.auxJasper.ParametroJasper.push(parametroJasperFl);
      await this.auxJasper.ParametroJasper.push(parametroJasper);

      this.imprime  = true;
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }

  async imprimirReciboPago(_idSolicitudDetalle) {
    try { 
      const datoRetorno =  await this.solicitudesService.getPago(_idSolicitudDetalle).toPromise();
 

      if (datoRetorno) 
      {
        this.auxJasper = new AuxJasper();
        this.auxJasper.JasperReport.nombreReporte = "001_Factura";
        this.auxJasper.JasperReport.tipo = "pdf";
  
        let parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "reimpresion";
        parametroJasper.valor = "true";
  
        let parametroJasperFl = new ParametroJasper();
        parametroJasperFl.nombre = "timbre";
        parametroJasperFl.valor = (datoRetorno?.uuid == null ? "false" : "true");

        let parametroJasperF2 = new ParametroJasper();
        parametroJasperF2.nombre = "_id_factura";
        parametroJasperF2.valor = datoRetorno?.id + "";
  
        await this.auxJasper.ParametroJasper.push(parametroJasperFl);
        await this.auxJasper.ParametroJasper.push(parametroJasperF2);
        await this.auxJasper.ParametroJasper.push(parametroJasper);

        
        this.imprime  = true;
      }
 
 
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }

  // Función para confirmar el regreso del flujo, validando que se haya ingresado la observación
  async confirmarRegreso() {
    try{

      if (!this.observacionRegreso || this.observacionRegreso.trim() === '') {
        this.muestraMensaje.warning("La observación es requerida", "top", "center");
        return;
      }
  
      this.fti  = new FlujoTramitesInput();      
      this.fti.idSolicitudDetalle = this.idSolicitud;
      this.fti.inicio = false;
      this.fti.idUsuario = null;
      this.fti.idEstatus = null;
      this.fti.idEtapaTramite = null;
      this.fti.observaciones = this.observacionRegreso.toUpperCase();
      this.fti.regresaFlujo = true;

  
      const datoRetorno = await this.flujoTramitesInputService.getBusquedas(this.fti).toPromise();
      this.muestraMensaje.notification("Guardar con éxito","top","center");

      // Emitir evento al padre
      this.getMonitoreoFlujoTramite(this.MonitoreoFlujoTramiteInput);
      
    // Cerrar el diálogo
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por confirmarRegreso")
      this.VentanaRegresaFlujo = false;
    }
  }
   // Método para determinar si la fila debe mostrarse
   shouldDisplayRow(row: any): boolean {
    if (row.estadoTramite === 'SOLICITUD') {
      return true;
    }
    if (row.estadoTramite === 'CONTRATACIÓN (FIRMA)' && row.estatus === 'TERMINADO') {
      return true;
    }
    if (row.estadoTramite === 'IMPRESIÓN' && row.estatus === 'TERMINADO') {
      const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000; // Milisegundos en una semana
      const fechaTramite = new Date(row.fecha); // row.fecha es "2025-02-11T10:36:59.773375"
      const ahora = new Date();
      const diferencia = ahora.getTime() - fechaTramite.getTime();
      
      // Si la diferencia es menor o igual a una semana, se permite la acción (reimpresión)
      if (diferencia <= ONE_WEEK_MS) {
        return true;
      }
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'EN PROCESO'){
      return true;
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'TERMINADO'){
      return true;
    }
    if (row.rutaPagina && !row.fecha) {
      return true;
    }
    return false;
  }

  // Método para obtener el icono adecuado
  getButtonIcon(row: any): string {
    if (row.estadoTramite === 'SOLICITUD') {
      return 'pi pi-print';
    }
    if (row.estadoTramite === 'CONTRATACIÓN (FIRMA)' && row.estatus === 'TERMINADO') {
      return 'pi pi-file';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'EN PROCESO'){
      return 'pi pi-undo';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'TERMINADO'){
      return 'pi pi-print';
    }
    return 'pi pi-directions';
  }

  // Método para obtener la clase CSS adecuada
  getButtonClass(row: any): string {
    if (row.estadoTramite === 'SOLICITUD') {
      return 'p-button-solicitud';
    }
    if (row.estadoTramite === 'CONTRATACIÓN (FIRMA)' && row.estatus === 'TERMINADO') {
      return 'p-button-contrato';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'EN PROCESO'){
      return 'p-button-regresa_flujo';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'TERMINADO'){
      return 'p-button-solicitud';
    }
    return 'p-button-directions';
  }
  // Método para obtener el tooltip adecuado
  getButtonTooltip(row: any): string {
    if (row.estadoTramite === 'SOLICITUD') {
      return 'Imprimir solicitud';
    }
    if (row.estadoTramite === 'CONTRATACIÓN (FIRMA)' && row.estatus === 'TERMINADO') {
      return 'Ver contrato firmado';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'EN PROCESO'){
      return 'Regresar flujo';
    }
    if(row.estadoTramite === 'COBRO' && row.estatus === 'TERMINADO'){
      return 'Imprimir Recibo';
    }
    return 'Navegar a la dirección';
  }
}
